<ng-container *ngIf="cardList.length !== 0; else noData">
  <ng-container
    *ngFor="
      let trainingDay of cardList[0].eg_dias ? cardList[0].eg_dias : cardList
    "
  >
    <ng-container *ngIf="trainingDay.isDesc">
      <div class="desc" [innerHtml]="trainingDay.descripcion | safeHtml"></div>
    </ng-container>
    <ion-card
      style="margin-bottom: 20px; border-radius: 13px"
      *ngIf="!trainingDay.isDesc"
    >
      <ion-card-header>
        <img
          *ngIf="trainingDay.avatar && from != 'training'"
          style="
            height: 120%;
            width: 100px;
            position: absolute;
            left: 0;
            bottom: -15px;
            z-index: 10;
            object-fit: cover;
          "
          [src]="trainingDay.avatar"
          alt=""
        />
        <div
          class="day"
          *ngIf="from == 'training' && !trainingDay.isNoDay"
          style="
            background-color: rgb(34, 34, 34);
            width: 24%;
            height: 120%;
            position: absolute;
            left: 0;
            bottom: -15px;
            z-index: 10;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <h3 style="color: white; margin-bottom: 20px">
            DÍA {{ trainingDay.numero }}
          </h3>
        </div>
        <ion-item
          lines="none"
          (click)="expandItem(trainingDay)"
          *ngIf="from !== 'training'; else trainingItem"
        >
          <ion-card-title
            [ngStyle]="{ 'margin-left.px': trainingDay.avatar ? '90' : '0' }"
            ><h6
              style="font-size: 15px; letter-spacing: -0.2px; font-weight: bold"
            >
              {{ trainingDay.nombre }}


              <ng-container *ngIf="from === 'training'">
                ({{
                  trainingDay.obligatorio == "1" ? "Obligatorio" : "Opcional"
                }})
              </ng-container>
            </h6>
            <!--  TODO: Add link button -->
            <ion-button
              color="success"
              *ngIf="trainingDay.compra_url"
              (click)="openPurchaseLink(trainingDay.compra_url)"
            >
              <ion-icon name="cart-outline"></ion-icon>
              {{ comprarText }}
            </ion-button>
          </ion-card-title
          >
          <ion-icon
            [name]="trainingDay.expanded ? 'chevron-up' : 'chevron-down'"
            slot="end"
          ></ion-icon>
        </ion-item>
        <ng-template #trainingItem>
          <ion-item lines="none" (click)="openDesc(trainingDay)">
            <ion-card-title
              [ngStyle]="{
                'margin-left.%': cardImg && !trainingDay.isNoDay ? '25' : '0'
              }"
              ><h5
                style="
                  font-size: 15px;
                  letter-spacing: -0.2px;
                  font-weight: bold;
                "
              >
                {{ trainingDay.nombre }}
                <ng-container
                  *ngIf="from === 'training' && !trainingDay.isNoDay"
                >
                  ({{
                    trainingDay.obligatorio == "1" ? "Obligatorio" : "Opcional"
                  }})
                </ng-container>
              </h5></ion-card-title
            >
            <ion-icon name="chevron-forward" slot="end"></ion-icon>
          </ion-item>
        </ng-template>
      </ion-card-header>

      <ion-card-content>
        <app-expandable [expanded]="trainingDay.expanded" expandHeight="850px">
          <ng-container *ngIf="trainingDay.no_data; else showData">
            <ion-row>
              <ion-col size="12">
                <ion-text color="dark">
                  <h3 style="margin-bottom: 8px">
                    {{ trainingDay.no_data }}
                  </h3>
                </ion-text>
              </ion-col>
            </ion-row>
          </ng-container>
          <ng-template #showData>
            <!-- TITUTLO Y DESC  -->
            <ion-row >
              <ion-col size="12">
                <ion-text
                  color="dark"
                  class="ion-text-center"
                  *ngIf="trainingDay.titulo"
                >
                  <h2 style="font-weight: bold">{{ trainingDay.titulo }}</h2>
                </ion-text>
                <p *ngIf="trainingDay.descripcion">
                  <ng-container
                    *ngIf="from !== 'training' && from !== 'places'; else desc"
                  >
                    <p style="margin-top: 15px">
                      {{ trainingDay.descripcion }}
                    </p>
                  </ng-container>

                  <ng-template #desc>
                    <div
                      style="margin-top: 8px"
                      [innerHtml]="trainingDay.descripcion | safeHtml"
                    ></div>
                  </ng-template>
                </p>
              </ion-col>
            </ion-row>
            <!-- FEEDING CARD -->
            <ng-container *ngIf="from === 'feeding'">
              <ion-grid fixed>
                <ion-row>
                  <ion-col size="12">
                    <ion-item>
                      <button
                        style="background: transparent"
                        (click)="incrementPage(-1)"
                      >
                        <ion-icon
                          style="font-size: 23px"
                          name="arrow-back-circle-outline"
                          slot="end"
                          color="medium"
                        ></ion-icon>
                      </button>
                      <button
                        style="background: transparent"
                        (click)="incrementPage(1)"
                      >
                        <ion-icon
                          name="arrow-forward-circle-outline"
                          style="font-size: 23px"
                          slot="end"
                          color="medium"
                        ></ion-icon>
                      </button>
                      <ion-label>Página</ion-label>
                      <ion-input
                        type="number"
                        [(ngModel)]="page"
                        pattern="-?[0-9]*(\.[0-9]+)?"
                        style="width: 60px"
                      ></ion-input>

                      <ion-label *ngIf="pdf">de {{ pdf.numPages }}</ion-label>
                      <button
                        style="background: transparent"
                        (click)="incrementZoom(-0.1)"
                      >
                        <ion-icon
                          style="font-size: 23px"
                          name="remove-circle-outline"
                          slot="end"
                          color="medium"
                        ></ion-icon>
                      </button>
                      <button
                        style="background: transparent"
                        (click)="incrementZoom(0.1)"
                      >
                        <ion-icon
                          name="add-circle-outline"
                          style="font-size: 23px"
                          slot="end"
                          color="medium"
                        ></ion-icon>
                      </button>
                    </ion-item>
                  </ion-col>

                  <ion-col size="12" *ngIf="trainingDay.recurso; else spinner">
                    <h1 *ngIf="isLoaded; else spinner"></h1>
                    <pdf-viewer
                      [src]="trainingDay.recurso"
                      [(page)]="page"
                      [original-size]="originalSize"
                      [fit-to-page]="fitToPage"
                      (after-load-complete)="afterLoadComplete($event)"
                      [zoom]="zoom"
                      [show-all]="showAll"
                      [stick-to-page]="stickToPage"
                      [render-text]="renderText"
                      [external-link-target]="'blank'"
                      [autoresize]="autoresize"
                      (on-progress)="onProgress($event)"
                      (page-rendered)="pageRendered($event)"
                    ></pdf-viewer>
                  </ion-col>
                  <ion-col size="12">
                    <ion-button
                      expand="block"
                      shape="round"
                      color="primary"
                      (click)="downloadPdf(trainingDay.recurso)"
                    >
                      Descargar pdf
                    </ion-button>
                  </ion-col>
                  <ng-template #spinner>
                    <div class="spinner" style="height: 100%; width: 100%">
                      <ion-row>
                        <ion-col
                          size="12"
                          style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                          "
                        >
                          <ion-spinner></ion-spinner>
                        </ion-col>
                      </ion-row>
                    </div>
                  </ng-template>
                </ion-row>
              </ion-grid>
            </ng-container>

            <!-- OLD CARD  -->
            <!-- NORMAL CARD   -->
            <ng-container
              *ngIf="from !== 'feeding' && !trainingDay.descripcion"
            >
              <ion-row *ngFor="let bloque of trainingDay.eg_bloques">
                <ion-col
                  size="12"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    flex-direction: column;
                  "
                >
                  <ion-text color="dark">
                    <h2 style="font-weight: bold">
                      {{ bloque.metodologia.nombre }}
                    </h2>
                  </ion-text>
                  <!-- EJERCICIOS  -->
                  <ng-container
                    *ngFor="let exercise of bloque.eg_bloque_ejercicios"
                  >
                    <div
                      style="margin-left: -40px; margin-top: 8px"
                      [innerHtml]="exercise.descripcion_enlace | safeHtml"
                    ></div>
                  </ng-container>
                  <!-- EXPLICACION EJERCICIO  -->

                  <ion-text color="dark">
                    <h2
                      style="
                        margin-bottom: 8px;
                        margin-top: 8px;
                        font-weight: bold;
                      "
                      (click)="bloque.showDescripcion = !bloque.showDescripcion"
                    >
                      {{ bloque.titulo }}
                      <ion-icon
                        [name]="
                          !bloque.showDescripcion
                            ? 'chevron-down-outline'
                            : 'chevron-up-outline'
                        "
                        slot="end"
                        *ngIf="trainingDay.expanded"
                      ></ion-icon>
                    </h2>
                  </ion-text>
                  <ion-text>
                    <p
                      class="animate__animated animate__slideInUp"
                      style="margin-bottom: 8px; font-size: 14px"
                      *ngIf="bloque.showDescripcion"
                    >
                      {{ bloque.descripcion }}
                    </p>
                  </ion-text>
                </ion-col>
              </ion-row>

              <!-- VIDEO  -->
            </ng-container>
            <ng-container
              *ngIf="from == 'places' || from == 'tecniques' || from == 'tips' || from == 'products'"
            >
              <ion-row>
                <ion-col style="display: flex;justify-content: center;align-items: center;">
                  <ng-container
                    *ngIf="trainingDay.video_url && trainingDay.loaded"
                  >
                  <div class="fluidMedia" >
                    <iframe
                    class="responsive-iframe"

                    [src]="trainingDay.video_url | safe"
                    allowfullscreen
                  >
                  </iframe>
                  </div>

                  </ng-container>
                </ion-col>
              </ion-row>
            </ng-container>
          </ng-template>
        </app-expandable>
      </ion-card-content>
    </ion-card>
  </ng-container>
</ng-container>
<ng-template #noData>
  <ion-card>
    <ion-card-header>
      <h1>No hay ejercicios con esos parametros</h1>
    </ion-card-header>
  </ion-card>
</ng-template>
